import React, { useEffect, useState } from "react";
import { Row, Col, Modal, Form, Button, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { showwishlist } from "../../Reducer/wishlistReducer";
import { showcartlist } from "../../Reducer/cartReducer";
import { showaccount } from "../../Reducer/homeReducer";
import { ToastContainer } from "react-toastify";
import QuickSearchmain from "./QuickSearchmain";
import { s3_img_url } from "../../Helper/request";
const Top_header = (props) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const home = useSelector(state => state?.persistedReducer?.home);
    const wishlist = useSelector((state) => state.persistedReducer.wish);
    const cart = useSelector((state) => state.persistedReducer.cart);

    // window.woopra.config({
    //     domain: "weddingdaydiamonds.com",
    //     outgoing_tracking: true,
    //     download_tracking: true,
    //     click_tracking: true
    //   });
    
    //   window.woopra.identify({
    //     search: search
    //   });
    
    // window.woopra.track();

    return (
        <>
        
         <ToastContainer />
            <section className="top_header">
            {
                    props.width > 992 ?     <Row>
                    <Col md={6} className="p-0">
                    <div className="top_header_box bg_primary text-center mobile_hide" style={{background:'#879794'}}>
                            <Link to="#" style={{pointerEvents: 'none'}}>   
                            {/* <img style={{width: "10px", marginRight: "6px"}} src={s3_img_url + "home/star.png"} alt="" /> */}
                            Free Shipping on All Orders</Link>
                        </div>
                    </Col>
                    <Col md={6} className="p-0">
                    <div className="top_header_box bg_secondary text-center mobile_hide" style={{background:'#6f7f80'}}>
                            <Link to="#" style={{pointerEvents: 'none'}}>
                              {/* <img style={{width: "10px", marginRight: "6px"}} src={s3_img_url + "home/star.png"} alt="" />  */}
                              Free Gift with Purchase</Link>
                        </div>
                    
                    </Col>
                </Row> :   <div className="greenBg text-center colorWhite py-2 ls3 topOfferMsg fs13 marquee-container" style={{background:'#6f7f80'}}>
                    <div className="marquee">
                    {/* <img style={{width: "10px", marginRight: "6px",marginLeft: "6px"}} src={s3_img_url + "home/star.png"} alt="" /> */}
                    Free Shipping on All Orders | Free Gift with Purchase
                    {/* <img style={{width: "10px", marginRight: "6px",marginLeft: "6px"}} src={s3_img_url + "home/star.png"} alt="" />  */}
                     
                    </div>
           
                </div>
                }
                <div className="top_links">
                    <div className="top_header_container">
                        <Row>
                            <Col md={6}>
                            {
                                props.width > 991 &&      <div className="top_links_box mobile_hide">
                                <ul>
                                    <li>
                                        <Link to="tel:1-866-740-7464">
                                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 320 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"></path></svg>
                                            1-866-740-RING
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/showroom">
                                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" version="1.1" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"></path></svg> 
                                            FIND A SHOWROOM
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/book-an-appointment" className="text-uppercase">
                                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"></path></svg>
                                             Book an Appointment
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            }
                           
                            </Col>
                            <Col md={6}>
                                <div className="top_icon_box text-end mobile_hide">
                                    <ul>
                                        {
                                            props?.width > 991 &&     <li className="mobile_hide position-relative">
                                            
                                            <QuickSearchmain/>

                                          
                                        </li>
                                        }
                                         {
                                            props?.width > 991 &&  
                                            <li className="mobile_hide">
                                            <div className="Login_dropdown_form">
                                                <span
                                                    className="header-icon account"
                                                    onClick={() => {
                                                        dispatch(showwishlist(false));
                                                        dispatch(showcartlist(false));
                                                        dispatch(showaccount(!home?.showaccount));
                                                    }}
                                                ></span>
                                            </div>
                                        </li>
                                            }
                                   
                                        {
                                            props?.width > 991 &&       <li className="mobile_hide">
                                            <div className="cart_dropdown_top wishlist_dropdown_top">
                                                <div
                                                    onClick={() => {
                                                        dispatch(showwishlist(!wishlist?.show));
                                                        dispatch(showcartlist(false));
                                                        dispatch(showaccount(false));
                                                    }}
                                                >
                                                    <span className="header-icon wishlist"></span>
                                                    {wishlist?.wishlistlength ? (
                                                        <span className="wish_item_count">
                                                            {wishlist?.wishlistlength}
                                                        </span>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>
                                            </div>
                                        </li>
                                        }
                                   
                                        <li className="desktop_hide">
                                            <Link to="#" aria-label="Search">
                                                <span className="header-icon search"></span>
                                            </Link>
                                        </li>
                                        <li>
                                            <div className="cart_dropdown_top">
                                                <div
                                                    onClick={() => {
                                                        dispatch(showcartlist(!cart?.show));
                                                        dispatch(showwishlist(false));
                                                        dispatch(showaccount(false));
                                                    }}
                                                >
                                                    <span className="header-icon cart"></span>
                                                    {cart?.cartlengthvalue ? (
                                                        <span className="cart_item_count">
                                                            {cart?.cartlengthvalue}
                                                        </span>
                                                    ) : (
                                                        <span className="cart_item_count">
                                                            0
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                {
                    props.width > 991 &&   <div className="brand-name text-center mobile_hide">
                    <Link to="/" aria-label="Logo">
                        <img  src={s3_img_url + 'logo.webp'} alt="Wedding Days Diamond" />
                    </Link>
                </div>
                }
              
            </section>

     



        </>
    );
};

export default Top_header;
